/* ILHA · AVALIAÇÕES DA FICHA (assets/ilha-avaliacoes.js) · 11/10/2026
   Saiu de dentro de `templates/product.ilha.liquid` porque o modelo passou o limite de 256 KB da Shopify (a subida foi
   recusada). Carrega-se com `defer` logo a seguir à secção «O que dizem os clientes» e não depende de nada da ficha: a
   loja e o produto vêm dos atributos `data-loja` e `data-id` da caixa do Judge.me. Três partes, pela ordem de sempre:
   esconder a secção vazia, ir buscar ao Judge.me as avaliações que o produto não traz, e as 3 à vista com o botão. */
(function () {
  /* ---------- esconder a secção de reviews se o widget vier vazio ----------
     A regra Liquid já esconde quando não há reviews (rating_count = 0). Isto
     apanha os casos em que o Judge.me não renderiza: pré-visualização do tema,
     ou a app a falhar na loja ao vivo. Reaparece quando as reviews carregam. */
  (function () {
    var w = document.querySelector('.jdgm-review-widget');
    if (!w) return;
    var sec = w.closest('section');
    if (!sec) return;
    function vazio() {
      return !w.querySelector('.jdgm-rev, .jdgm-histogram, [data-review-id]') && w.textContent.trim().length < 5;
    }
    function sync() { sec.style.display = vazio() ? 'none' : ''; }
    sync();
    try { new MutationObserver(sync).observe(w, { childList: true, subtree: true }); } catch (e) {}
    setTimeout(sync, 3500);
  })();

  /* ⭐ 11/10/2026 · AVALIAÇÃO QUE O JUDGE.ME NÃO GUARDOU NO PRODUTO. No Risfort Permanente (1 avaliação, de 1 estrela) e
     noutros, o `judgeme.review_widget_ssr_html` não existe e o `judgeme.widget` é `<div></div>`: a caixa ia vazia, o bloco
     de cima escondia a secção e a cliente via «1» ao lado das estrelas sem poder ler a opinião (Silva: «tem que aparecer
     para o cliente ver… senão não é uma opinião verificada»). Quando a caixa continua vazia depois de o script do Judge.me
     correr, pede-se ao servidor público dele (o mesmo que o widget usa, `cdn.judge.me`, com CORS aberto) e desenha-se com
     as classes dele, para ficar igual. ⛔ O texto da avaliação entra como TEXTO, nunca como HTML. */
  (function () {
    var w = document.querySelector('.jdgm-review-widget');
    if (!w) return;
    var LOJA = w.getAttribute('data-loja') || '', PRODUTO = w.getAttribute('data-id') || '';
    function temAlguma() { return !!w.querySelector('.jdgm-rev'); }
    function el(tag, cls, texto) { var e = document.createElement(tag); if (cls) e.className = cls; if (texto != null) e.textContent = texto; return e; }
    function dataPT(iso) { var d = new Date(iso); if (isNaN(d)) return ''; function z(n) { return (n < 10 ? '0' : '') + n; } return z(d.getDate()) + '/' + z(d.getMonth() + 1) + '/' + d.getFullYear(); }
    function corpo(html) {
      var div = el('div', 'jdgm-rev__body');
      /* (auditoria) o Judge.me manda «Péssimo \n<br />Não obtive…»: o \n e o <br> juntos davam uma linha em branco a mais */
      var txt = new DOMParser().parseFromString(String(html || '').replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p>/gi, '\n'), 'text/html').body.textContent || '';
      var p = el('p'), primeira = true;
      txt.split(/\s*\n\s*/).forEach(function (linha) {
        linha = linha.trim();
        if (!linha) return;
        if (!primeira) p.appendChild(document.createElement('br'));
        p.appendChild(document.createTextNode(linha));
        primeira = false;
      });
      div.appendChild(p);
      return div;
    }
    /* A mesma estrutura que o script do Judge.me deixa nas avaliações dele depois de correr (lida ao vivo no Rapunzel a
       11/10): linha das estrelas e da data, linha do perfil com o ícone, o nome e o selo «Verificado» (que o CSS dele escreve
       sozinho, por isso o span vai vazio), e o corpo. Com `jdgm--done-setup`, o CSS dele mostra o selo. */
    function desenhar(revs) {
      var raiz = el('div', 'jdgm-ssr-reviews'), lista = el('div', 'jdgm-ssr-reviews__list');
      revs.forEach(function (r) {
        var n = Math.max(0, Math.min(5, Math.round(Number(r.rating) || 0)));
        var rev = el('div', 'jdgm-rev jdgm-divider-top jdgm--done-setup');
        rev.setAttribute('data-verified-buyer', r.verified_buyer ? 'true' : 'false');
        var cab = el('div', 'jdgm-rev__header');
        cab.appendChild(el('div', 'jdgm-row-product'));
        var lin = el('div', 'jdgm-row-rating');
        var est = el('span', 'jdgm-rev__rating');
        est.setAttribute('data-score', n); est.setAttribute('role', 'img'); est.setAttribute('aria-label', n + (n === 1 ? ' estrela' : ' estrelas'));
        for (var i = 0; i < 5; i++) est.appendChild(el('span', 'jdgm-star ' + (i < n ? 'jdgm--on' : 'jdgm--off')));
        var quando = el('time', 'jdgm-rev__timestamp', dataPT(r.created_at));
        quando.setAttribute('datetime', r.created_at || '');
        quando.setAttribute('data-content', String(r.created_at || '').replace('T', ' ').replace(/\.\d+Z$|Z$/, ' UTC'));
        lin.appendChild(est); lin.appendChild(quando);
        var perfil = el('div', 'jdgm-row-profile');
        perfil.appendChild(el('div', 'jdgm-rev__icon'));
        var aw = el('span', 'jdgm-rev__author-wrapper');
        aw.appendChild(el('span', 'jdgm-rev__author', r.is_anonymous_reviewer ? 'Anónimo' : (r.reviewer_name || 'Cliente')));
        if (r.verified_buyer) { var bw = el('span', 'jdgm-rev__buyer-badge-wrapper'); bw.appendChild(el('span', 'jdgm-rev__buyer-badge')); aw.appendChild(bw); }
        perfil.appendChild(aw);
        /* (reauditoria) a linha extra e o título vazio também existem nas do Judge.me: sem eles o texto subia e a 1.ª linha
           encostava-se ao ícone, 88 px para a direita */
        var extra = el('div', 'jdgm-row-extra'); extra.appendChild(el('span', 'jdgm-rev__location'));
        cab.appendChild(lin); cab.appendChild(perfil); cab.appendChild(extra); cab.appendChild(el('div', 'jdgm-rev__br'));
        var cont = el('div', 'jdgm-rev__content');
        cont.appendChild(el('b', 'jdgm-rev__title', r.title || ''));
        cont.appendChild(corpo(r.body_html));
        rev.appendChild(cab); rev.appendChild(cont); lista.appendChild(rev);
      });
      raiz.appendChild(lista);
      w.textContent = '';
      w.appendChild(raiz);
    }
    function buscar() {
      if (temAlguma() || !LOJA || !PRODUTO || !window.fetch) return;
      fetch('https://cdn.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(LOJA) + '&shop_domain=' + encodeURIComponent(LOJA)
        + '&platform=shopify&page=1&per_page=30&product_id=' + encodeURIComponent(PRODUTO))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.reviews && d.reviews.length && !temAlguma()) desenhar(d.reviews); })
        .catch(function () { /* sem rede ou o Judge.me em baixo: fica como estava */ });
    }
    /* dá tempo ao script do Judge.me de a encher sozinho; só se continuar vazia é que se pede */
    if (document.readyState === 'complete') setTimeout(buscar, 2500);
    else window.addEventListener('load', function () { setTimeout(buscar, 2500); });
  })();

  /* ⭐ 10/10/2026 · AVALIAÇÕES: TRÊS À VISTA, O RESTO NUM BOTÃO. O Judge.me desenha-as todas de uma vez: no Rapunzel eram
     33 e 5 487 px no telemóvel, e num produto com 300 a página não acabava (Silva: «tá rolando, rolando… nunca acaba»).
     Ficam à frente as 3 mais recentes, com as estrelas que tiverem (ordem do Silva, 11/10) e o botão abre mais 10 de cada vez. As escondidas
     continuam no HTML, onde o Google as lê. ⛔ Por dentro o bloco continua a ser do Judge.me: só se reordena e esconde.
     Se o script dele redesenhar a lista, o observador volta a arrumar. */
  (function () {
    var w = document.querySelector('.jdgm-review-widget');
    if (!w || !w.parentNode) return;
    var PRIMEIRAS = 3, DE_CADA_VEZ = 10;
    var mostrar = PRIMEIRAS;
    /* 10/10 (Silva: «do mesmo jeito que pode abrir, pode fechar») · dois botões lado a lado: «Ver mais avaliações» e
       «Ver menos», que volta às 3 e sobe ao título da secção, para a cliente não ficar perdida a meio da página. */
    var botoes = document.createElement('div');
    botoes.className = 'itp-av-botoes';
    botoes.hidden = true;
    var botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'itp-av-mais';
    botao.hidden = true;
    var menos = document.createElement('button');
    menos.type = 'button';
    menos.className = 'itp-av-mais itp-av-menos';
    menos.textContent = 'Ver menos';
    menos.hidden = true;
    botoes.appendChild(botao);
    botoes.appendChild(menos);
    w.parentNode.insertBefore(botoes, w.nextSibling);
    /* «2026-09-06 07:37:08 UTC» → data; sem data vai para o fim */
    function quando(r) {
      var e = r.querySelector('.jdgm-rev__timestamp');
      var t = (e && e.getAttribute('data-content')) || '';
      var d = Date.parse(t.replace(' UTC', 'Z').replace(' ', 'T'));
      return isNaN(d) ? 0 : d;
    }
    var aArrumar = false;
    function arrumar() {
      if (aArrumar) return;
      var revs = [].slice.call(w.querySelectorAll('.jdgm-rev'));
      if (!revs.length) { botoes.hidden = true; return; }
      aArrumar = true;
      try {
        /* (auditoria) · sem marca na lista: calcula-se sempre quem deve ir à frente e só se mexe se não estiver. Assim
           volta a arrumar se o Judge.me reescrever a lista por dentro. */
        var lista = revs[0].parentNode;
        var porData = revs.slice().sort(function (a, b) { return quando(b) - quando(a); });
        /* ⛔ 11/10 (Silva) · AS 3 MAIS RECENTES, TENHAM AS ESTRELAS QUE TIVEREM. A 1.ª regra punha à frente as de 5 estrelas;
           o Silva corrigiu: «se tem uma estrela, que tem duas… é as três primeiras que vai ficar na frente, que é o certo». */
        var frente = porData.slice(0, PRIMEIRAS);
        var certo = true;
        for (var c = 0; c < frente.length; c++) if (revs[c] !== frente[c]) { certo = false; break; }
        if (!certo) {
          for (var i = frente.length - 1; i >= 0; i--) if (frente[i].parentNode === lista) lista.insertBefore(frente[i], lista.firstChild);
          revs = [].slice.call(w.querySelectorAll('.jdgm-rev'));
        }
        /* a nota do Judge.me vem em inglês e diz uma coisa verdadeira: traduz-se, não se esconde */
        var notaIngles = w.querySelector('.jdgm-ssr-borrowed-reviews-note');
        if (notaIngles && /related products/i.test(notaIngles.textContent)) notaIngles.textContent = 'Algumas destas avaliações são de produtos da mesma família, que a loja juntou a este.';
        for (var k = 0; k < revs.length; k++) revs[k].classList.toggle('itp-av--fora', k >= mostrar);
        var faltam = revs.length - mostrar;
        botao.hidden = faltam <= 0;
        menos.hidden = mostrar <= PRIMEIRAS || revs.length <= PRIMEIRAS;
        botoes.hidden = botao.hidden && menos.hidden;
        /* sem número: o Judge.me só manda parte das avaliações para a página (33 das 108 no Rapunzel), e «30 por ver»
           ao lado de «108 avaliações» lá em cima parecia um erro */
        if (faltam > 0) botao.textContent = 'Ver mais avaliações';
      } finally { aArrumar = false; }
    }
    botao.addEventListener('click', function () {
      var antes = mostrar;
      mostrar += DE_CADA_VEZ;
      arrumar();
      /* quem usa teclado ou leitor de ecrã continua na primeira das que acabaram de abrir */
      var nova = w.querySelectorAll('.jdgm-rev')[antes];
      if (nova) { nova.setAttribute('tabindex', '-1'); try { nova.focus({ preventScroll: true }); } catch (e) {} }
    });
    menos.addEventListener('click', function () {
      mostrar = PRIMEIRAS;
      arrumar();
      var sec = w.closest('section') || w;
      sec.classList.add('itp-av-sec');
      try { sec.scrollIntoView({ block: 'start' }); } catch (e) { sec.scrollIntoView(); }
      /* o foco não pode ficar num botão que acabou de desaparecer */
      try { botao.focus({ preventScroll: true }); } catch (e) {}
    });
    arrumar();
    try { new MutationObserver(arrumar).observe(w, { childList: true, subtree: true }); } catch (e) {}
    setTimeout(arrumar, 3500);
  })();

})();
